import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';
import { FontFamily, HighlightColor, Truncate } from '../../shared-styles';

export const StyledCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 12px 8px 18px;
  background-color: ${COLOR_OPTIONS.WHITE};
  border-radius: 8px;
  min-width: 180px;
  position: relative;
  overflow: hidden;
  border: 1px solid ${COLOR_OPTIONS.WHITE};
  cursor: pointer;

  &:hover {
    border: 1px solid ${COLOR_OPTIONS.BLUE_30};
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  }
`;

export const StyledCardHeader = styled.div`
  display: flex;
`;

export const StyledTrapInfo = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

export const StyledTrapName = styled.div`
  ${FontFamily}
  ${Truncate}
  font-size: 16px;
  font-weight: 600;
  color: ${COLOR_OPTIONS.NEUTRAL_100};
  margin-bottom: 4px;
`;

export const StyledTrapId = styled.div`
  ${FontFamily}
  font-size: 12px;
  color: ${COLOR_OPTIONS.NEUTRAL_50};
`;

export const StyledHighlightBar = styled.div<{ color: string; bgStrong: boolean }>`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 6px;

  ${HighlightColor}
`;

export const FlightPredictionWrapper = styled.div`
  display: flex;
  margin-left: 8px;
`;
